﻿const History = window.History; // Note: We are using a capital H instead of a lower h
function getActivePrices() {
    const greenButtons = $('[data-price] a.btn-green');
    const values = $.map(greenButtons, function (element, index) {
        return $(element).attr('value');
    });
    return values.join(',');
}

function updatePrices(event) {
    $(event.target).toggleClass('btn-green').toggleClass('btn-primary');
    event.preventDefault();
    window.updateResults();
}

function validateCustomForm() {
    $("#deal-contact-box").validate({
        rules: {
            Email: {
                required: true,
                email: true
            }
        }
    });
}
function submitContactForm(e) {
    const form = $(e.target);
    if (!form.valid())
        return;
    e.preventDefault();
    $.post(form.attr("action"), form.serialize(), function (response) {
        $('[id^=deal-thankyou]').empty();
        const dealId = $("#Deal_Id").val();
        const message = $('[data-thankyou-message]').data('thankyou-message');
        $("#deal-thankyou-" + dealId).empty().append("<div class='alert alert-success'>" + message + "</div>");
        const currentfeatherlight = $.featherlight.current();
        if (currentfeatherlight) {
            currentfeatherlight.close();
        }
    });
}

function getData(page) {
    const manufacturerId = $('#ManufacturerId').val();
    const modelGroupId = $('#ModelGroupId').val();
    const sortBy = $('#SortBy').val();
    const manufacturerName = $("#ManufacturerName").val();
    const modelName = $("#ModelName").val();
    const mileagePerAnnum = $('#MileagePerAnnum').val();
    const priceFilter = getActivePrices();
    return {
        ManufacturerId: manufacturerId,
        ModelGroupId: modelGroupId,
        ManufacturerName: manufacturerName,
        ModelName: modelName,
        MileagePerAnnum: mileagePerAnnum,
        PriceFilter: priceFilter,
        SortBy: sortBy,
        Page: page
    };
}

function buildUpQueryString(data) {
    let queryString = "";

    if (queryString.length > 0) queryString += "&";
    queryString += "Manufacturer=" + data.ManufacturerName;

    if (queryString.length > 0) queryString += "&";
    queryString += "Model=" + data.ModelName;

    if (queryString.length > 0) queryString += "&";
    queryString += "MileagePerAnnum=" + data.MileagePerAnnum;

    if (queryString.length > 0) queryString += "&";
    queryString += "PriceFilter=" + data.PriceFilter;

    if (queryString.length > 0) queryString += "&";
    queryString += "SortBy=" + data.SortBy;

    if (data.Page > 1) {
        if (queryString.length > 0) queryString += "&";
        queryString += "Page=" + data.Page;
    }

    return "?" + queryString;
}

function updateResultsLogic(page) {
    const data = getData(page);
    History.pushState(data, $('title').html(), location.pathname + buildUpQueryString(data));
}

function getPage(href) {
    const querystring = href.split('?')[1];
    const parts = querystring.split('&');
    return $.grep(parts, function (el, index) {
        return el.split('=')[0] === "p";
    })[0].split('=')[1];
}

function setManufacturer(href) {
    if (href.indexOf('?') > 1) {
        const querystring = href.split('?')[1];
        const parts = querystring.split('&');
        if (href.indexOf('ManufacturerId') > 1) {
            const manId = $.grep(parts, function (el, index) {
                return el.split('=')[0] === "ManufacturerId";
            })[0].split('=')[1];
            $.get("/manufacturer-url/" + manId, function (response) {
                $("#ManufacturerName").val(response);
            });
        } else if (href.indexOf('Manufacturer') > 1) {
            const manufacturer = $.grep(parts, function (el, index) {
                return el.split('=')[0] === "Manufacturer";
            })[0].split('=')[1];

            $("#ManufacturerName").val(manufacturer);
        }
    }
}

function setModel(href) {
    if (href.indexOf('?') > 1) {
        const querystring = href.split('?')[1];
        const parts = querystring.split('&');
        if (href.indexOf('ModelGroupId') > 1) {
            const modelId = $.grep(parts, function (el, index) {
                return el.split('=')[0] === "ModelGroupId";
            })[0].split('=')[1];
            const manufacturerId = $.grep(parts, function (el, index) {
                return el.split('=')[0] === "ManufacturerId";
            })[0].split('=')[1];
            $.get("/model-url/" + manufacturerId + "/" + modelId, function (response) {
                $("#ModelName").val(response);
            });
        } else if (href.indexOf('Model') > 1) {
            const model = $.grep(parts, function (el, index) {
                return el.split('=')[0] === "Model";
            })[0].split('=')[1];

            $("#ModelName").val(model);
        }
    }
}


function reloadQuery() {
    const State = History.getState();
    $.ajaxSetup({cache: false});
    $.get('/deals/query', State.data, function (response) {
        $('#deals-page-query-container').replaceWith(response);
    });
}

function markAsLoading() {
    $('#deals-page-results-container').text('').html('<div class="d-flex justify-content-center"><div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div></div>');
}

function pageData(event) {
    $('html, body').animate({
        scrollTop: 0
    }, 400);
    event.preventDefault();
    if ($(this).attr('href') === undefined)
        return;
    const page = getPage($(this).attr('href'));
    updateResultsLogic(page);
}

function onChangeFilters(event) {
    const currentDropdown = ($(this).attr("name"));
    if (currentDropdown === "ManufacturerId") {
        $("#ModelGroupId").val('');
        $("#ModelName").val('');
        $.get("/manufacturer-url/" + $(this).val(), function (response) {
            $("#ManufacturerName").val(response);
            window.updateResults();
        });
    } else if (currentDropdown === "ModelGroupId") {
        if (parseInt($(this).val()) > 0) {
            const manufacturerId = $('#ManufacturerId').val();
            $.get(`/manufacturer-url/${manufacturerId}`, function (response) {
                $("#ManufacturerName").val(response);
            });
            $.get(`/model-url/${manufacturerId}/${$(this).val()}`, function (response) {
                $("#ModelName").val(response);
                window.updateResults();
            });
        } else {
            $("#ModelName").val('');
            window.updateResults();
        }
    } else {
        window.updateResults();
    }
}


export function setupDealsPage() {
    if ($('[data-deals-page]').length) {
        window.updateResults = function () {
            updateResultsLogic(1);
        }
        $.featherlight.defaults.afterOpen = validateCustomForm;
        jQuery.validator.setDefaults({
            success: "valid"
        });
        setManufacturer(window.location.href);
        setModel(window.location.href);
        //dropdown changes
        $(document).on('change', '[data-deals-page] input, [data-deals-page] select', onChangeFilters);

        //paging click
        $(document).on('click', '#deals-page-results-container .pagination a', pageData);

        //fuel type button chagnes
        $(document).on('click', '[data-price] a', updatePrices);

        $(document).on("submit", "[data-deal-contact-form]", submitContactForm);
        // Bind to StateChange Event
        //History.Adapter.bind(window, 'statechange', function () { // Note: We are using statechange instead of popstate#
        //    markAsLoading();
        //    reloadQuery();
        //    const State = History.getState();
        //    setTimeout(
        //        function () {
        //            $.get('/deals/results', State.data, function (response) {
        //                $('#deals-page-results-container').replaceWith(response);
        //            });
        //        }, 600);
        //});

    }
}
